// extracted by mini-css-extract-plugin
module.exports = {"punkCard":"PunkCard_punkCard__1vlF1","punkCardContent":"PunkCard_punkCardContent__j2Ip5","randomButton":"PunkCard_randomButton__1ISRK"};